import styled from 'styled-components'

import { Button } from '@procsea/design-system'

export const StyledAIButton = styled(Button)<{ isShortButton?: boolean }>`
  background-color: white;
  ${props => props.isShortButton && 'height: 33px;'}
  ${props =>
    !props.isShortButton && `margin: -${props.theme.spacings.small} ${props.theme.spacings.small};`}
  

  & span[data-e2e='button-text'] {
    display: inline-block;
    background: linear-gradient(90deg, deepskyblue, purple, deepskyblue);
    background-size: 200% auto;
    background-position: 0% center;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    transition: background-position 0.5s ease;
  }

  & svg > path {
    color: deepskyblue;
    transition: color 0.5s ease-in-out;
  }

  &::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    z-index: -1;
    border-radius: 6px;
    background: linear-gradient(90deg, deepskyblue, purple, deepskyblue);
    background-size: 200% auto;
    background-position: 0% center;
    transition: background-position 0.5s ease;
  }

  &:hover {
    background-color: white;
  }

  &:hover span[data-e2e='button-text'] {
    background-position: 100% center;
    color: transparent;
  }

  &:hover svg > path {
    color: purple;
  }

  &:hover::before {
    background-position: 100% center;
  }

  & div[data-e2e='inner-button'] {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`
